import { createStyles } from "antd-style";

const useStyles = createStyles(({ css, token }) => {
  return {
    novelWorkspace: css`
    display: flex;
    height: 100vh;
    /* 与论文库同一暖纸面壳，避免写作页偏冷灰 */
    background: var(--tt-bg, ${token.colorBgLayout});
    color: var(--tt-ink, ${token.colorText});
  `,
    novelWorkspaceSidebar: css`
      border-color: var(--ant-color-border);

      .sidebar-header-title {
        flex: 1;
        padding: 0 8px;
        transition: all 0.3s;
        border-radius: 4px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        strong {
          font-size: 16px;
          color: ${token.colorText};
          font-weight: normal;
        }
        div {
          color: ${token.colorTextSecondary};
        }
      }

      .sidebar-tab-active{
        color: ${token.colorPrimary};
        border-color: ${token.colorPrimary};
      }
    `,
  }
});

export default useStyles;